import React from 'react';
import { YStack } from '@tamagui/stacks';
import Svg, { Path, Defs, LinearGradient, Stop, Rect } from 'react-native-svg';

interface Props {
  children: React.ReactNode;
  height?: number;
  width?: string | number;
  offsetLeft?: number;
  offsetTop?: number;
  placement?: 'top' | 'bottom';
  offsetBottom?: number;
  borderTopLeftRadius?: number;
  borderTopRightRadius?: number;
  variant?: 'curve' | 'flat' | 'symmetric';
  edgeY?: number;
  curveDepth?: number;
  borderBottomLeftRadius?: number;
  borderBottomRightRadius?: number;
}

const SvgBackground: React.FC<Props> = ({
  children,
  height = 220,
  width = '100%',
  offsetLeft = 10,
  offsetTop = -150,
  placement = 'top',
  offsetBottom = -150,
  borderTopLeftRadius,
  borderTopRightRadius,
  variant = 'curve',
  edgeY = 110,
  curveDepth = 60,
  borderBottomLeftRadius,
  borderBottomRightRadius,
}) => {
  return (
    <YStack
      height={height}
      position="relative"
      width={width}
      borderTopLeftRadius={borderTopLeftRadius}
      borderTopRightRadius={borderTopRightRadius}
      borderBottomLeftRadius={borderBottomLeftRadius}
      borderBottomRightRadius={borderBottomRightRadius}
      overflow={
        borderTopLeftRadius ||
        borderTopRightRadius ||
        borderBottomLeftRadius ||
        borderBottomRightRadius
          ? 'hidden'
          : 'visible'
      }
    >
      <YStack
        position="absolute"
        {...(placement === 'top' ? { top: offsetTop } : { bottom: offsetBottom })}
        left={offsetLeft}
        width="115%"
        height={height + Math.abs(offsetTop) + 100}
        zIndex={1}
      >
        <Svg width="100%" height="100%" viewBox="0 0 401 326" style={svgStyle}>
          <Defs>
            <LinearGradient
              id="paint0_linear_554_4669"
              x1="352.5"
              y1="-294"
              x2="352.5"
              y2="326"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#A6597A" />
              <Stop offset="1" stopColor="#5E809C" />
            </LinearGradient>
          </Defs>
          {variant === 'curve' ? (
            <Path
              d="M705 17.1834C705 189.118 568.32 307.011 342.545 326C-115.079 313.008 17.9939 189.25 17.9939 17.3151C17.9939 -154.619 172.791 -294 363.743 -294C554.695 -294 705 -154.751 705 17.1834Z"
              fill="url(#paint0_linear_554_4669)"
              fillOpacity="0.75"
            />
          ) : variant === 'flat' ? (
            <Rect x="-300" y="-300" width="1200" height="1000" fill="url(#paint0_linear_554_4669)" fillOpacity="0.75" />
          ) : (
            <Path
              d={`M -80,-300 H 520 V ${edgeY} Q 220,${edgeY + curveDepth} -80,${edgeY} Z`}
              fill="url(#paint0_linear_554_4669)"
              fillOpacity="0.75"
            />
          )}
        </Svg>
      </YStack>

      <YStack
        flex={1}
        alignItems="center"
        justifyContent="center"
        space="$3"
        zIndex={5}
        pointerEvents="box-none"
      >
        {children}
      </YStack>
    </YStack>
  );
};

const svgStyle = {
  position: 'absolute' as const,
};

export default SvgBackground;
